import {
	Button,
	Flex,
	FormControl,
	FormErrorMessage,
	FormLabel,
	Heading,
	Input,
	Stack,
	useColorModeValue
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
export default function TagForm({ defaultValues, onFormSubmit, onFormCancel}) {
	const {
		handleSubmit,
		register,
		formState: { errors, isSubmitting },
	} = useForm({ defaultValues });
	const onSubmit = handleSubmit((data) => {
		onFormSubmit(data);
	});
	return (
		<Flex
			minH={"100vh"}
			justify={"center"}
			bg={useColorModeValue("gray.50", "gray.800")}>
			<Stack
				spacing={4}
				w={"full"}
				maxW={"md"}
				bg={useColorModeValue("white", "gray.700")}
				rounded={"xl"}
				boxShadow={"lg"}
				p={6}
				my={12}>
				<Heading lineHeight={1.1} fontSize={{ base: "2xl", sm: "3xl" }}>
					{defaultValues ? <span>Editing tag: {defaultValues.name}</span> : <span>Adding tag</span>}
				</Heading>
				<FormControl id='name' isRequired isInvalid={errors.name}>
					<FormLabel>Name</FormLabel>
					<Input
						id='name'
						{...register("name", {
							required: true,
							minLength: 1,
						})}
					/>
					<FormErrorMessage>
						{errors.name && errors.name.message}
					</FormErrorMessage>                        
				</FormControl>
				<FormControl id='slug' isRequired isInvalid={errors.slug}>
					<FormLabel>Slug</FormLabel>
					<Input
						id='slug'
						{...register("slug", {
							required: true,
							minLength: 1,
						})}
					/>
					<FormErrorMessage>
						{errors.slug && errors.slug.message}
					</FormErrorMessage>
				</FormControl>                                                                     
				<Stack spacing={6} direction={["column", "row"]}>
					{defaultValues ? 
						<Button
							bg={"red.400"}
							color={"white"}
							w='full'
							_hover={{
								bg: "red.500",
							}}
							onClick={() => onFormCancel()}>
                            Cancel
						</Button> 
						:
						null
					}   
					<Button
						bg={"blue.400"}
						color={"white"}
						w='full'
						_hover={{
							bg: "blue.500",
						}}
						isLoading={isSubmitting}
						onClick={() => onSubmit()}
					>
                            Submit
					</Button>
				</Stack>
			</Stack>
		</Flex>
	);
}